import type { FieldValue } from '@/data/schemas/fieldPatterns.schemas';
import { normalizeFieldText } from '@/data/fieldPatterns';

export function resolveFieldValueLabel(
  value: FieldValue | null | undefined,
  options: Array<{ id: string; label: string }> = []
): string {
  if (!value) return '';
  if (value.kind === 'option') {
    return options.find((option) => option.id === value.optionId)?.label ?? value.optionId;
  }
  if (value.kind === 'custom' || value.kind === 'text') {
    return normalizeFieldText(value.text);
  }
  return '';
}
